/**
 * What a visitor wants when they start an assessment from a reusable invite link
 * (`/onboard/:advisorId`) with an email that already has a client under that advisor.
 *
 * The public invite endpoint (`postClientInviteForPublic`) no longer guesses: on the
 * first submit it answers `requiresChoice`, the page asks the visitor, and the second
 * submit carries one of these values.
 *
 * - `continue`: open the assessment already on this email, always behind sign-in so a
 *   stranger who knows the email cannot read someone else's answers.
 * - `startOver`: a fresh assessment for the same person. It creates a NEW client and
 *   leaves the earlier one untouched in the account (nothing is wiped), so it is the
 *   same server path as `someoneElse`; only the visitor's intent differs.
 * - `someoneElse`: a separate assessment for another person who shares the email
 *   (a spouse, a parent). Deliberately not linked as a partner, because the
 *   relationship is unknown.
 */
export enum ReturningIntakeChoice {
  CONTINUE = 'continue',
  START_OVER = 'startOver',
  SOMEONE_ELSE = 'someoneElse',
}
